import dayjs, { Dayjs } from 'dayjs';  // Importando dayjs
import { useEffect, useState } from 'react';

// Atualize a assinatura da função
export const subtractDates = (date1: Dayjs, date2: Dayjs): number => {
  if (!date1 || !date2) {
    return 0;
  }

  // Atualizando a função diff para usar dayjs
  return date2.diff(date1, 'day');
};

export const useDateDifference = (dates: Dayjs[] | null): { dayDifference: number, weeklyDifference: number } => {
  const [dayDifference, setDayDifference] = useState(0);
  const [weeklyDifference, setWeeklyDifference] = useState(0);


  useEffect(() => {
    if (!dates || dates.length < 2) {
      setDayDifference(0);
      setWeeklyDifference(0);
    } else {
      const diff = subtractDates(dates[0], dates[1]);
      setDayDifference(diff);
      setWeeklyDifference(() => {
        const midStay = diff > 26 && diff < 29 ? Math.ceil(diff / 7) + 1 : Math.ceil(diff / 7);
        return midStay
      });
    }
  }, [dates]);
  return { dayDifference, weeklyDifference };
};
